"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var rateDriver = _interopRequireWildcard(require("@/api/rateDriver"));
var _date = require("@/utils/date");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _format = require("@/utils/format");
var _moment = _interopRequireDefault(require("moment"));
var _vuex = require("vuex");
var _enum = require("@/utils/enum");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  props: {
    driverId: {
      type: Number,
      default: null
    },
    showFilterArea: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      listLoading: false,
      total: 0,
      baseUrl: process.env.VUE_APP_BASE_API,
      baseUrlMedia: process.env.VUE_APP_BASE_URL_MEDIA,
      listQuery: {
        page: 1,
        limit: 10,
        search: "",
        driverId: null,
        star: null
      },
      tableData: [],
      tagOptions: _enum.tagOptions,
      ORDER_FOOD_STATUS: _enum.ORDER_FOOD_STATUS,
      ORDER_DELIVERY_STATUS: _enum.ORDER_DELIVERY_STATUS,
      ORDER_TRANSPORT_STATUS: _enum.ORDER_TRANSPORT_STATUS
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapState)({
    areas: function areas(state) {
      return state.area.list;
    }
  })),
  created: function created() {
    if (!this.driverId) {
      if (!!this.$store.state.user.info.area) {
        this.listQuery.areaId = this.$store.state.user.info.area.id;
      }
      this.getTableData();
      this.$store.dispatch("area/fetchList");
    }
  },
  watch: {
    driverId: function driverId() {
      this.getTableData();
    }
  },
  methods: {
    formatNumberVN: function formatNumberVN(n) {
      return (0, _format.formatNumberVN)(n);
    },
    formatCurrency: function formatCurrency(n) {
      return (0, _format.formatCurrency)(n);
    },
    getTableData: function getTableData() {
      var _this = this;
      this.listLoading = true;
      this.listQuery.driverId = this.driverId;
      rateDriver.findAll(this.listQuery).then(function (res) {
        _this.tableData = res.data.rateDrivers;
        _this.total = res.data.total;
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    formatDateTime: function formatDateTime(timestamp) {
      return (0, _date.formatDateTime)(timestamp);
    }
  }
};